import { render, staticRenderFns } from "./ListFiles.vue?vue&type=template&id=48052984&scoped=true"
import script from "./ListFiles.vue?vue&type=script&lang=js"
export * from "./ListFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48052984",
  null
  
)

export default component.exports